import { ZoneType } from "@/codegen/openapi2";
import { TextCell } from "@/components/2/text-cell/text-cell";

type ZoneNameCellProps = {
  zone: ZoneType;
  onUpdate?: (zone: ZoneType, field: string, value: string) => void;
};

export const ZoneNameCell = ({ zone, onUpdate }: ZoneNameCellProps) => {
  return (
    <TextCell
      value={zone.name}
      onSave={onUpdate ? value => onUpdate(zone, "name", value) : undefined}
      placeholder="Zone name"
    />
  );
};
